import h from "./createElement";

export default new class {
    _timeout = {};

    _alert_handler(type, text, time) {
        if (this._timeout[type]) return;

        const wrapper = inject_wrapper(), alert = get_alert(type, text);

        wrapper.appendChild(alert);
        dismiss_alert(alert, this, type, time)
    }


    warning(text = "", time = 3000) { this._alert_handler("warning", text, time) };

    info(text = "", time = 3000) { this._alert_handler("info", text, time) };

    success(text = "", time = 3000) { this._alert_handler("success", text, time) };

    danger(text = "", time = 3000) { this._alert_handler("danger", text, time) };

    progress(text = "") {
        const wrapper = inject_wrapper(), alert = get_alert('progress', text);

        const bar = <div class="bar"></div>;

        alert.appendChild(bar);

        wrapper.appendChild(alert);

        return {
            progress: (progress = 0) => bar.setAttribute('style', `--percent: ${Math.min(100, progress)};`),
            dismiss: () => dismiss(alert)
        };
    };
};

function dismiss_alert(alert, instance, type, time) {

    setTimeout(() => {
        dismiss(alert)
        instance._timeout[type] = false;
    }, time);

    instance._timeout[type] = true;
};

function dismiss(alert) {
    alert.addEventListener("animationend", () => alert.remove())
    alert.classList.add('dismiss')
}

function get_alert(type, text) {
    return <article class={"alert " + type}><span>{text}</span></article>
}

function inject_wrapper() {
    const main_section = document.querySelector('section.alert-wrapper') || h('section', { class: 'alert-wrapper' });
    if (!main_section.isConnected) document.body.appendChild(main_section);
    return main_section;
};